// TODO ReportSummary remove style

import clsx from "clsx";
import { CSSProperties, PropsWithChildren } from "react";

import styles from "./rlcard.module.scss";

type Props = {
  className?: string;
  style?: CSSProperties;
};

const RLCardHeader: React.FC<PropsWithChildren<Props>> = ({
  children,
  className,
  style = {}
}) => (
  <div style={style} className={clsx(styles.rlcard_header, className)}>
    {children}
  </div>
);

export default RLCardHeader;
